import React from 'react';
import './Loader.scss';

type Loader = Record<string, never>;

export const Loader: React.FC<Loader> = () => {
  return (
    <>
      <div className={`${'loading-maskLayer'}`}>
        <div className="loading-icon loading large"></div>
      </div>
    </>
  );
};
